'use client';

import useSWR from 'swr';

import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';

import { TypeAddressRecord } from '../types';

export default function useAddress(addressUuid: string) {
  const uri = `${API_URLS.ACCOUNT_MANAGER_PROXY}/addresses/${addressUuid}`;

  const { data, error, mutate, isLoading } = useSWR<TypeAddressRecord, Error>(
    uri,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    addressData: data,
    addressError: error,
    addressMutate: mutate,
    addressLoading: isLoading,
  };
}
